import { ThemeType } from "./types";

// TESTING CONSTS
export const TESTING_ENABLED = false; // process.env.NODE_ENV === "development";
export const TEST_GAME = "Art-ificial";
// END TESTING CONSTS

export const PLAYER_NAME_MAX_LENGTH = 10;
export const TIME_BUFFER_SECONDS = 3;
export const DEFAULT_HOST_NAME = window.location.hostname;
const isDevelopment =
  process.env.NODE_ENV === "development" ||
  DEFAULT_HOST_NAME.includes("localhost");
const prefix = isDevelopment ? "ws://" : "wss://";
export const DEFAULT_WEBSOCKET_PORT = isDevelopment
  ? 50666
  : window.location.port ?? 443; // Default port for WebSocket connections
export const WEBSOCKET_URL = `${prefix}${DEFAULT_HOST_NAME}:${DEFAULT_WEBSOCKET_PORT}`;
export const GAMENIGHTTV_CAST_APP_ID = "6E758851"; // GameNightTV Cast App ID
export const GAMENIGHTTV_CAST_CHANNEL = "urn:x-cast:com.gamenighttv.ping"; // Custom channel for GameNightTV
export const HOST_CONNECTION_TIMEOUT_MS = 3000; // 3 seconds
export const PING_TIMER_INTERVAL_MS = 60000; // 1 minute
export const SILENT_MP3_TIMER_INTERVAL_MS = 60000 * 4; // 4 minutes
export const RECEIVER_TIMEOUT_SEC = 60 * 60; // 60 minutes

export enum Games {
  Lobby = "Join to Choose a Game!",
  Artificial = "Art-ificial",
  MEMErable = "MEMErable",
  CAH = "Cards Against Humanity",
  Trivia = "Trivia",
  TriviaLies = "TriviaLies",
}
export const DEFAULT_THEME: ThemeType = {
  BackgroundColor: "#000000",
  TextColor: "#FFFFFF",
  ButtonColor: "#555555",
  ReminderColor: "#FFFF00",
  Font: "Arial, sans-serif",
};
